<script lang="ts">
	import { ArrowDown, ArrowUp } from 'lucide-svelte';
	import { fade } from 'svelte/transition';

	type Props = {
		question: {
			question: string;
			answer: string;
		};
		searchTerm: string;
	};

	let { question, searchTerm }: Props = $props();
	let show = $state(false);

	const setShow = (v: boolean) => {
		show = v;
	};

	const highlight = (searchTerm: string, text: string) => {
		const regex = new RegExp(searchTerm, 'gi');
		return text.replace(regex, (match) => `<span class="bg-yellow-300 text-black">${match}</span>`);
	};

	$effect(() => {
		if (searchTerm === '') {
			setShow(false);
		} else {
			setShow(true);
		}
	});
</script>

<div>
	<button class="flex items-center gap-x-2" onclick={() => setShow(!show)}>
		<h3 class:text-primary={show} class:text-secondary={!show} class="text-lg font-normal">
			{question.question}
		</h3>
		<div class="text-slate-500">
			{#if !show}
				<ArrowDown size={20} />
			{:else}
				<ArrowUp size={20} />
			{/if}
		</div>
	</button>
	{#if show}
		<p class="whitespace-pre-line" transition:fade={{ duration: 150 }}>
			<!-- eslint-disable svelte/no-at-html-tags -->
			{@html highlight(searchTerm, question.answer)}
		</p>
	{/if}
</div>
